import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import LandingTrelloHelmet from 'common/helmets/LandingTrelloHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LandingLogos from 'common/LandingLogos';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import UppercaseHeader from 'common/UppercaseHeader';
import withContexts from 'common/util/withContexts';
import Roadmap from 'img/landing/roadmap.webp';
import TrelloLogo from 'img/landing/trello-logo.webp';

import CannyLogo from 'img/canny-wordmark-white.svg';
import Chris from 'img/chris.jpg';
import StarImage from 'img/white-star.png';

import 'css/components/www/_LandingComparisonPage.scss';

class LandingTrello extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Trello Page');
  }

  render() {
    return (
      <div className="landingTrello landingComparisonPage">
        <LandingTrelloHelmet />
        <div className="fullWidthContainer">
          <div className="header">
            <h1>Canny is a simple, focused Trello roadmap&nbsp;alternative</h1>
            <div className="subheading"></div>
            <Link className="cta" to="/register">
              <Button buttonType="greenButton" value="Get Started" />
            </Link>
            <div className="headerImg">
              <LazyLoadedImage loading="eager" src={Roadmap} alt="Canny is a Trello alternative" />
            </div>
          </div>
        </div>
        <div className="landingFeaturesContainer">
          <h1>Trello is a generic tool, Canny was made for this</h1>
          <div className="comparisonChart">
            <div className="header">
              <div className="canny">
                <LazyLoadedImage src={CannyLogo} alt="Canny logo" />
              </div>
              <div className="competitorLogo trello">
                <LazyLoadedImage src={TrelloLogo} alt="Trello logo" />
              </div>
            </div>
            <div className="comparison">
              <div className="point">
                <div className="title">Look professional</div>
                <div className="description">
                  The Canny experience is optimized specifically for customer&nbsp;feedback.
                </div>
              </div>
              <div className="point">
                <div className="title">Look cheap</div>
                <div className="description">
                  Trello was not made for this and your customers will be able to&nbsp;tell.
                </div>
              </div>
            </div>
            <div className="comparison">
              <div className="point">
                <div className="title">Connect to existing user&nbsp;accounts</div>
                <div className="description">
                  Automatically understand who is giving you&nbsp;feedback.
                </div>
              </div>
              <div className="point">
                <div className="title">Users must have a Trello&nbsp;account</div>
                <div className="description">
                  This creates a barrier for them and gets you less&nbsp;feedback.
                </div>
              </div>
            </div>
            <div className="comparison">
              <div className="point">
                <div className="title">Keep users updated</div>
                <div className="description">
                  We'll notify your users when you reply or update&nbsp;statuses.
                </div>
              </div>
              <div className="point">
                <div className="title">Disconnected feedback&nbsp;loops</div>
                <div className="description">
                  Your attempts to respond or give updates will be left&nbsp;unheard.
                </div>
              </div>
            </div>
            <div className="comparison">
              <div className="point">
                <div className="title">Identify your team</div>
                <div className="description">
                  Everyone on your team who responds will have a&nbsp;
                  <div className="badge">
                    <LazyLoadedImage className="star" src={StarImage} />
                  </div>
                  &nbsp;next to their name.
                </div>
              </div>
              <div className="point">
                <div className="title">Get lost in the crowd</div>
                <div className="description">
                  Your team's responses look the same as any user's&nbsp;response.
                </div>
              </div>
            </div>
            <div className="comparison">
              <div className="point">
                <div className="title">First class support</div>
                <div className="description">
                  You won’t need us often but when you do, we’ll be&nbsp;here.
                </div>
              </div>
              <div className="point">
                <div className="title">Poor support</div>
                <div className="description">
                  Fill out the support form and wait in line for a&nbsp;response.
                </div>
              </div>
            </div>
          </div>
          <div className="quoteContainer">
            <LazyLoadedImage src={Chris} />
            <div className="text">
              <UppercaseHeader>Words from a happy convert</UppercaseHeader>
              <div className="quote">
                "We had a scary Trello board and support was adding emails as comments on each card
                when they got an email with feature requests. It&nbsp;was a hot&nbsp;mess."
              </div>
              <div className="credit">Chris Scott, Co-Founder at Swift&nbsp;Galleries</div>
            </div>
          </div>
          <LandingLogos />
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default compose(withContexts({ trackEvent: TrackEventContext }))(LandingTrello);
